var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 125,
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.4999 104.167C80.9092 104.167 104.166 98.3434 104.166 87.3052C104.166 86.0408 104.428 78.6367 92.8026 78.1261C77.6511 78.1261 71.9617 78.125 62.4999 78.125C53.0382 78.125 47.3489 78.1261 32.1974 78.1261C20.5721 78.6366 20.8338 86.0408 20.8338 87.3052C20.8338 98.3434 44.0906 104.167 62.4999 104.167Z",
    stroke: "#EF233C",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7292 41.6667C80.7292 53.1726 72.5677 62.5 62.5 62.5C52.4323 62.5 44.2708 53.1726 44.2708 41.6667C44.2708 30.1608 52.4323 20.8334 62.5 20.8334C72.5677 20.8334 80.7292 30.1608 80.7292 41.6667Z",
    stroke: "#EF233C",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.2b22227c772470a0a31d113737b56ed3.svg";
export { ForwardRef as ReactComponent };